import { render, staticRenderFns } from "./VacancyCandidatesPrehired.vue?vue&type=template&id=c57b110c&scoped=true"
import script from "./VacancyCandidatesPrehired.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesPrehired.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesPrehired.vue?vue&type=style&index=0&id=c57b110c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57b110c",
  null
  
)

export default component.exports